<template>
  <ModalPrimary v-bind="modalAttrs"
                :name="name">
    <ImageUploadPrimary :maxSizeKB="maxSizeKB"
                        :resetTrigger="resetTrigger"
                        :style="{ height: '300px' }"
                        :uploadingFile="uploadingFile"
                        @upload-file="uploadFile" />
  </ModalPrimary>
</template>

<script>
  import ApiCurrentUserImage from '@js/api/current-user-image'
  import ImageUploadPrimary from '@modules/image/image-upload-primary'
  import ModalPrimary from '@modules/modal/modal-primary'
  import { MODAL_WINDOW_NAMES, USER_PROFILE_LIMITS } from '@js/constants'
  import { compressImageFile } from '@js/file-utils'

  export default {
    name: 'ModalUploadUserImage',
    components: {
      ModalPrimary,
      ImageUploadPrimary,
    },
    data: function () {
      return {
        imageUploadStyle: {
          height: '300px',
        },
        maxSizeKB: USER_PROFILE_LIMITS.IMAGE_SIZE_MAX_KB,
        modalAttrs: {
          maxWidth: 360,
          minHeight: 360,
        },
        name: MODAL_WINDOW_NAMES.UPLOAD_USER_IMAGE_PRIMARY,
        resetTrigger: false,
        uploadingFile: false,
      };
    },
    methods: {
      uploadFile: async function (payload) {
        try {
          this.uploadingFile = await true;
          const compressedFile = await compressImageFile(
            payload.file,
            USER_PROFILE_LIMITS.IMAGE_COMPRESSION_SIZE_MAX_KB,
            USER_PROFILE_LIMITS.IMAGE_COMPRESSION_MAX_SIZE,
          );
          payload.formData = await new FormData();
          await payload.formData.append('image', compressedFile, compressedFile.name);
          //const res = await this.$store.dispatch('user/updateImage', payload);
          const api = await new ApiCurrentUserImage();
          const res = await api.put(payload.formData);
          await this.$store.commit(
            'notification/setMessage', 'Uploaded user image.');
          await this.$store.commit('user/setUser', { image: res.data.image });
          await this.$modal.hide(this.name);
          this.uploadingFile = await false;
          this.resetTrigger = await !this.resetTrigger;
        } catch (error) {
          console.error(error);
        }
      },
    },
  };
</script>
